<template>
  <v-app>
      <appbar v-if="isLoggedIn" />
      <v-main>
        <router-view />
      </v-main>
      <appfooter v-if="isLoggedIn" />
  </v-app>
</template>

<script lang="ts">
    import { Vue, Component } from 'vue-property-decorator';
    import applicationModule from '@/store/modules/application.module';
    import ApplicationBar from '@/components/layout/ApplicationBar.vue';
    import ApplicationFooter from '@/components/layout/ApplicationFooter.vue';

    @Component({
      components: {
        'appbar': ApplicationBar,
        'appfooter': ApplicationFooter
      }
    })
    export default class App extends Vue {

      get isLoggedIn() : boolean {
        return applicationModule.isAuthorized;
      }

      mounted() : void {
      }

    }
</script>

<style scoped>

</style>